import {useEffect} from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import PublicModule from "pages/public/PublicModule";
import CommunityModule from "pages/community/CommunityModule";
import CampaignsModule from "pages/campaigns/CampaignsModule";
import InteractionsModule from "pages/interactions/InteractionsModule";
import AccountsModule from "pages/accounts/AccountsModule";

import PrivateRoute from "api/PrivateRoute";

function App() {

  useEffect(() => {
    const link = document.querySelector("link[rel='icon']") || document.createElement("link");
    link.setAttribute("rel", "icon");
    link.setAttribute("href", "/icons/app.ico");
    document.head.appendChild(link);
  }, []);

  
  return (
    <Router>
      <Routes>

        {/* PRIVATE MODULES */}
        <Route
          path="/community/*"
          element={
            <PrivateRoute>
              <CommunityModule />
            </PrivateRoute>
          }
        />

        <Route
          path="/campaigns/*"
          element={
            <PrivateRoute>
              <CampaignsModule />
            </PrivateRoute>
          }
        />

        <Route
          path="/interactions/*"
          element={
            <PrivateRoute>
              <InteractionsModule />
            </PrivateRoute>
          }
        />

        <Route
          path="/accounts/*"
          element={
            <PrivateRoute>
              <AccountsModule />
            </PrivateRoute>
          }
        />

        {/* PUBLIC MODULE */}
        <Route path="/*" element={<PublicModule />} />

      </Routes>
    </Router>
  );
}

export default App;
